"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAdminFeatureFlagCustomerSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("./get.js");
const name_1 = require("./_id/customer/name.js");
exports.removeAdminFeatureFlagCustomerSlice = (0, xuder_1.createRemoveSyncSlice)({
    name: name_1.UseDefaultAdminFeatureFlagName,
    state: get_1.getAdminFeatureFlagsSlice.asyncState,
    transform: (action, state) => {
        var _a, _b, _c;
        return ({
            featureFlags: (_b = (_a = state === null || state === void 0 ? void 0 : state.featureFlags) === null || _a === void 0 ? void 0 : _a.map((flag) => {
                if (flag.name === action.featureFlag) {
                    return Object.assign(Object.assign({}, flag), { exceptionCustomers: flag.exceptionCustomers.filter((customer) => customer.id !== action.customerId) });
                }
                return flag;
            })) !== null && _b !== void 0 ? _b : [],
            totalCustomerCount: (_c = state === null || state === void 0 ? void 0 : state.totalCustomerCount) !== null && _c !== void 0 ? _c : 0
        });
    }
});
//# sourceMappingURL=remove.js.map